const initHeight = () => {
    $('.back-to-top').addClass('long');
};

export {
    initHeight
};
